import Chart from "react-apexcharts";
import { Loading } from "../../../componentes/loading/loading";
import { formatarDataComDiaSemana } from "../../../utils/formatDate";

export function ProducaoDiaria({ report, loading }) {
  const field1 = "caixasPorDia";
  const field2 = "paletesPorDia";

  const labels = Object.keys({
    ...report[field1],
    ...report[field2],
  }).sort((a, b) => new Date(a) - new Date(b));

  // const labels = rawLabels.map(formatarDataComDiaSemana);

  const caixasPorDia = labels.map((date) => report[field1]?.[date] || 0);
  const paletesPorDia = labels.map((date) => report[field2]?.[date] || 0);

  const options = {
    chart: {
      type: "line",
      zoom: { enabled: true },
      toolbar: { show: true },
    },

    xaxis: {
      categories: labels,
      labels: {
        rotate: -45,
        rotateAlways: true,
        style: {
          fontSize: "10px",
        },
      },
    },

    dataLabels: {
      enabled: true,
    },


    legend: {
      position: "bottom",
    },

    responsive: [
      {
        breakpoint: 1024,
        options: {
          xaxis: {
            labels: {
              rotate: -45,
              style: { fontSize: "9px" },
            },
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          dataLabels: {
            enabled: false, // 🔥 desliga no mobile
          },
          xaxis: {
            labels: {
              rotate: -90,
              style: { fontSize: "8px" },
            },
          },
        },
      },
    ],

    colors: ["#3B82F6", "#10B981"],
  };

  const series = [
    { name: "Caixas", data: caixasPorDia },
    { name: "Paletes", data: paletesPorDia },
  ];

  return (
    <div
      style={{
        width: "100%",
        overflowX: labels.length > 10 ? "auto" : "hidden",
        overflowY: "hidden",
        maxHeight: labels.length > 10 ? 325 : null,
      }}

    >
      <div style={{ minWidth: labels.length > 10 ? "1200px" : "100%" }}>
        {!loading ? (
          <Chart
            options={options}
            series={series}
            type="line"
            height={labels.length > 10 ? 295 : 310}
          />
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}